<template>
  <article>
    <section class="xbed-sub-title">
      <span>智能硬件管理</span>
    </section>
    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>前台自助机管理</BreadcrumbItem>
        <BreadcrumbItem>前台自助机列表</BreadcrumbItem>
      </Breadcrumb>
    </section>
    <section style="margin-top:20px">
      <Form inline>
        <FormItem label="启用状态" :label-width="85">
          <Select style="width:160px" v-model="search.enable">
            <Option :value="-1">全部</Option>
            <Option :value="1">启用</Option>
            <Option :value="0">停用</Option>
          </Select>
        </FormItem>
        <FormItem label="机器状态" :label-width="85">
          <Select style="width:160px" v-model="search.machineStatus">
            <Option :value="-1">全部</Option>
            <Option :value="1">正常</Option>
            <Option :value="0">异常</Option>
          </Select>
        </FormItem><br>
        <FormItem label="关联门店" :label-width="85">
          <Input v-model="search.chain" placeholder="门店id/门店名"></Input>
        </FormItem>
        <FormItem label="机器码" :label-width="85">
          <Input v-model="search.machineCode"></Input>
        </FormItem>
        <FormItem>
          <Button @click="queryMachineList">查询</Button>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="addMachineEvent">添加自助机</Button>
        </FormItem>
      </Form>
      <Table :columns="columns" :data="list"></Table>
      <div style="margin: 10px;overflow: hidden">
        <Page show-sizer :current="search.page" :page-size="search.pageSize" :total="count" @on-change="handlenChange"
          @on-page-size-change="handlenChangeSize"></Page>
      </div>
    </section>
    <Modal v-model="addModal.display" :loading="true" title="添加自助机" @on-ok="addMachineBtn" ref="addModal">
      <Form :model="addModal.data" :rules="addModal.rules" ref="addForm">
        <FormItem label="型号" :label-width="65" prop="machineModel">
          <Select v-model="addModal.data.machineModel">
            <Option v-for="(item, key) in modelList" :key="key" :value="item">{{ item }}</Option>
          </Select>
        </FormItem>
        <FormItem label="机器码" :label-width="65" prop="machineCode">
          <Input v-model="addModal.data.machineCode" :maxlength="30"></Input>
        </FormItem>
      </Form>
    </Modal>
  </article>
</template>

<script>
import Utils from "../../../utils";
import API from "../../../api";
export default {
  async created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
  },
  mounted() {
    this.$Notice.config({
      top: 200
    });
    this.queryMachineList();
    this.queryMachineModelList();
  },
  data() {
    return {
      search: {
        page: 1,
        pageSize: 10,
        chain: '',
        enable: -1,
        machineCode: '',
        machineStatus: -1,
      },
      addModal: {
        display: false,
        data: {},
        rules: {
          machineModel: [
            { required: true, message: '请选择型号', trigger: 'change' }
          ],
          machineCode: [
            { required: true, message: '请填写机器码', trigger: 'blur' }
          ]
        }
      },
      columns: [
        {
          title: '自助机id',
          width: 100,
          align: 'center',
          key: 'id'
        },
        {
          title: '自助机型号',
          width: 190,
          align: 'center',
          key: 'machineModel'
        },
        {
          title: '机器码',
          width: 200,
          align: 'center',
          key: 'machineCode'
        },
        {
          title: '是否启用',
          width: 100,
          align: 'center',
          render: (h, param) => {
            return h('span', param.row.enable ? '启用' : '停用')
          }
        },
        {
          title: '机器状态',
          width: 100,
          align: 'center',
          render: (h, param) => {
            return h('span', param.row.machineStatus ? '正常' : '异常')
          }
        },
        {
          title: '安装地址',
          width: 250,
          align: 'center',
          render: (h, param) => {
            return h('p', `${param.row.installProvinceArea} ${param.row.installStreetAddress}`)
          }
        },
        {
          title: '经纬度',
          width: 300,
          align: 'center',
          key: 'latitudeLongitude'
        },
        {
          title: '门店数量',
          width: 100,
          align: 'center',
          key: 'chainNum'
        },
        {
          title: '操作',
          width: 200,
          align: 'center',
          render: (h, param) => {
            return h('div', [
              h('i-button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    if (this.$router) {
                      this.$router.push({ path: "/app/smart-device/detail", query: { id: param.row.id } });
                    } else {
                      window.open(`#/Order/Reserve/tamiMachineDetail?id=${param.row.id}`);
                    }
                  }
                }
              }, '详情'),
              h('i-button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                style: {
                  marginLeft: '5px'
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '删除自助机',
                      content: '<p>自助机删除后不可恢复数据</p><p>原绑定的门店可以在xbed客户端办理入住</p><p>确定删除？</p>',
                      onOk: () => {
                        this.delMachine(param.row.machineCode)
                      },
                    });
                  }
                }
              }, '删除')
            ])
          }
        },
      ],
      list: [],
      modelList: [],
      count: 10
    }
  },
  methods: {
    addMachineEvent() {
      this.addModal.data = {};
      this.addModal.display = true;
    },
    async queryMachineList() {
      const resp = (await API.omsAPI[this.env].deviceModule.queryMachineList(
        this.search,
        this.token
      )).data;
      if (resp.retCode) {
        this.$Notice.error({
          title: '获取自助机列表失败',
          desc: resp.msg
        })
        return
      }
      this.list = resp.list.map((item) => {
        for (let i in item) {
          if (item[i] === null) {
            item[i] = ''
          }
        }
        return item
      });
      this.count = resp.total;
    },
    addMachineBtn() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addModal.display = false;
          this.addMachine();
        } else {
          this.$refs.addModal.buttonLoading = false;
        }
      })
    },
    async addMachine() {
      const resp = (await API.omsAPI[this.env].deviceModule.addMachine(
        this.addModal.data.machineCode,
        this.addModal.data.machineModel,
        this.username,
        this.token
      )).data;
      if (resp.retCode) {
        this.$Notice.error({
          title: '添加失败',
          desc: resp.msg
        })
        return
      }
      this.queryMachineList();
    },
    async delMachine(id) {
      const resp = (await API.omsAPI[this.env].deviceModule.delMachine(
        id,
        this.username,
        this.token
      )).data;
      if (resp.retCode) {
        this.$Notice.error({
          title: '删除失败',
          desc: resp.msg
        })
        return
      }
      this.$Notice.success({
        title: '删除成功'
      })
      this.queryMachineList();
    },
    async queryMachineModelList() {
      const resp = (await API.omsAPI[this.env].deviceModule.queryMachineModelList(
        this.token
      )).data;
      if (resp.retCode) {
        this.$Notice.error({
          title: '获取自助机型号列表失败',
          desc: resp.msg
        })
        return
      }
      this.modelList = resp;
    },
    handlenChange(e) {
      this.search.page = e
      this.queryMachineList()
    },
    handlenChangeSize(e) {
      this.search.pageSize = e
      this.queryMachineList()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/smart-device/self-service-machine/index.vue